import { SavedSearchTypes } from './actionTypes';

const INIT_STATE = {
  savedSearches: [],
  filterList: [],
  filterData: {},
  isLoading: false,
  error: {},
  savedCompleted: false,
  searchDeleted: null,
};

const SavedSearches = (state = INIT_STATE, action: any) => {
  switch (action.type) {
    case SavedSearchTypes.GET_SAVED_SEARCHES:
      return {
        ...state,
        isLoading: true,
      };
    case SavedSearchTypes.GET_SAVED_SEARCHES_SUCCESS:
      return {
        ...state,
        savedSearches: action.payload,
        isLoading: false,
      };

    case SavedSearchTypes.GET_SAVED_SEARCHES_FAIL:
      return {
        ...state,
        error: action.payload,
        isLoading: false,
      };
    case SavedSearchTypes.GET_FILTER_DATA:
      return {
        ...state,
        isLoading: true,
      };

    case SavedSearchTypes.GET_FILTER_DATA_SUCCESS:
      return {
        ...state,
        filterData: action.payload,
        isLoading: false,
      };
    case SavedSearchTypes.GET_FILTER_DATA_FAIL:
      return {
        ...state,
        error: action.payload,
        isLoading: false,
      };
    case SavedSearchTypes.SAVE_SEARCH:
      return {
        ...state,
        isLoading: true,
        savedCompleted: false,
      };
    case SavedSearchTypes.SAVE_SEARCH_SUCCESS:
      return {
        ...state,
        isLoading: false,
        savedCompleted: true,
      };
    case SavedSearchTypes.SAVE_SEARCH_FAIL:
      return {
        ...state,
        error: action.payload,
        isLoading: false,
      };
    case SavedSearchTypes.DELETE_SEARCHES:
      return {
        ...state,
        isLoading: true,
        savedCompleted: false,
      };
    case SavedSearchTypes.DELETE_SEARCHES_SUCCESS:
      return {
        ...state,
        isLoading: false,
        savedCompleted: true,
        searchDeleted: action.payload,
      };
    case SavedSearchTypes.DELETE_SEARCHES_FAIL:
      return {
        ...state,
        error: action.payload,
        isLoading: false,
      };

    default:
      return state;
  }
};

export default SavedSearches;
